import './CopSubscription.scss';

import React, { useMemo } from 'react';

import { type CopSubscriptionProps, parseConfig } from './CopSubscription.config';
import SubscriptionForm from './SubscriptionForm';

const CopSubscription: React.FC<CopSubscriptionProps> = (props) => {
    const rawConfig = props.configJson || props['config-json'] || '';
    const config = useMemo(() => parseConfig(rawConfig), [rawConfig]);

    const subscriptionId = useMemo(() => {
        // 1. Check ?id= query parameter (most common AEM pattern)
        const fromSearch = new URLSearchParams(window.location.search).get('id');
        if (fromSearch) return fromSearch;
        // 2. Fallback: last path segment (e.g. /subscription.edit.html/{uuid})
        const segments = window.location.pathname.split('/');
        const last = segments[segments.length - 1]?.replace(/\.html$/, '');
        const uuidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
        return uuidPattern.test(last ?? '') ? last : undefined;
    }, []);

    return (
        <div className="subscription-modal">
            <SubscriptionForm config={config} subscriptionId={subscriptionId} />
        </div>
    );
};

export default CopSubscription;

